import { render, staticRenderFns } from "./DataRow.vue?vue&type=template&id=07ecd7fa&"
import script from "./DataRow.vue?vue&type=script&lang=js&"
export * from "./DataRow.vue?vue&type=script&lang=js&"
import style0 from "./DataRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports